// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IReferenceTokenResponse } from './IReferenceTokenResponse';
import {
    IReferenceTokenResponseFromJSON,
    IReferenceTokenResponseFromJSONTyped,
    IReferenceTokenResponseToJSON,
    IReferenceTokenResponseToJSONTyped,
} from './IReferenceTokenResponse';

/**
 * 
 * @export
 * @interface IAccount
 */
export interface IAccount {
    /**
     * 
     * @type {string}
     * @memberof IAccount
     */
    type?: IAccountTypeEnum;
    /**
     * 
     * @type {IReferenceTokenResponse}
     * @memberof IAccount
     */
    token?: IReferenceTokenResponse;
}

/**
* @export
* @enum {string}
*/
export enum IAccountTypeEnum {
    CREDIT = 'CREDIT',
    PREPAID = 'PREPAID',
    ACH = 'ACH',
    LOYALTY = 'LOYALTY',
    PAYPAL = 'PAYPAL',
    MASTERPASS = 'MASTERPASS',
    VENMO = 'VENMO',
    THREEDSECURE = 'THREEDSECURE',
    VAULTED_ACCOUNT = 'VAULTED_ACCOUNT',
    FLEET = 'FLEET',
    APPLE_PAY = 'APPLE_PAY',
    SAMSUNG_PAY = 'SAMSUNG_PAY',
    GOOGLE_PAY = 'GOOGLE_PAY',
    MONEYNETWORK = 'MONEYNETWORK',
    EBT = 'EBT'
}


/**
 * Check if a given object implements the IAccount interface.
 */
export function instanceOfIAccount(value: object): value is IAccount {
    return true;
}

export function IAccountFromJSON(json: any): IAccount {
    return IAccountFromJSONTyped(json, false);
}

export function IAccountFromJSONTyped(json: any, ignoreDiscriminator: boolean): IAccount {
    if (json == null) {
        return json;
    }
    return {
        
        'type': json['type'] == null ? undefined : json['type'],
        'token': json['token'] == null ? undefined : IReferenceTokenResponseFromJSON(json['token']),
    };
}

export function IAccountToJSON(json: any): IAccount {
    return IAccountToJSONTyped(json, false);
}

export function IAccountToJSONTyped(value?: IAccount | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'type': value['type'],
        'token': IReferenceTokenResponseToJSON(value['token']),
    };
}

